var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonAdd = function SvgPersonAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "personAdd_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#personAdd_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 11h-2a.968.968 0 0 1-.713-.287A.968.968 0 0 1 15 10c0-.283.096-.52.287-.713A.968.968 0 0 1 16 9h2V7c0-.283.096-.52.288-.713A.968.968 0 0 1 19 6c.283 0 .52.096.712.287.192.192.288.43.288.713v2h2c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 22 11h-2v2c0 .283-.096.52-.288.713A.968.968 0 0 1 19 14a.968.968 0 0 1-.712-.287A.968.968 0 0 1 18 13v-2Zm-9 1c-1.1 0-2.042-.392-2.825-1.175C5.392 10.042 5 9.1 5 8s.392-2.042 1.175-2.825C6.958 4.392 7.9 4 9 4s2.042.392 2.825 1.175C12.608 5.958 13 6.9 13 8s-.392 2.042-1.175 2.825C11.042 11.608 10.1 12 9 12Zm-8 6v-.8c0-.567.146-1.087.438-1.563.291-.475.679-.837 1.162-1.087a14.843 14.843 0 0 1 3.15-1.163A13.76 13.76 0 0 1 9 13c1.1 0 2.183.13 3.25.387 1.067.259 2.117.646 3.15 1.163.483.25.87.612 1.162 1.087.292.476.438.996.438 1.563v.8c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 15 20H3c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 1 18Z",
    fill: "#53B741"
  }))));
};
export default SvgPersonAdd;